document.addEventListener('DOMContentLoaded', function() {

  
  /*
   * Observer para detección de envío de formularios de la app de Shopify, detecta el popup de success
   */
  /*
  function attachSuccessObserver(formEmbed) {
    if (!formEmbed || formEmbed.dataset.gaObserverAttached) return;
    const shadow = formEmbed.shadowRoot;
    if (!shadow) return;
    const successObserver = new MutationObserver(() => {
      const banner = shadow.querySelector('[data-testid="banner-success"]');
      if (banner && !banner.dataset.gaTracked) {
        console.log("🎉 Popup de éxito detectado:", banner);
		if (typeof gtag == "function") {
			gtag("event", "adw_form_cupon");
		}
		if (typeof fbq == "function") {
			fbq("track", "Contact", { content_name: "telefono" });
		}
        // Marcar como procesado para evitar duplicados
        banner.dataset.gaTracked = "true";
      }
    });
    successObserver.observe(shadow, { childList: true, subtree: true });
    console.log("👀 Observando shadowRoot en busca del popup de éxito...");
    formEmbed.dataset.gaObserverAttached = "true";
  }
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.tagName?.toLowerCase() === "form-embed") {
          console.log("🔎 form-embed detectado:", node);
          if (node.shadowRoot) {
            attachSuccessObserver(node);
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  console.log("👀 Esperando <form-embed> para enganchar el popup...");  
  */
  
  /* 
    URL APP: https://apps.shopify.com/dondy-whatsapp-chat-widget
    Crear archivo en assets/custom_script.js
    una vez creado
    Agregar en layout/theme.liquid
    <script src="{{ 'custom_script.js' | asset_url }}" defer="defer"></script>
    plugin que usamos para whatsapp y que nos deja medir: Dondy: WhatsApp Chat+Marketing
    */
  /*
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          // Intentar encontrar el elemento con el ID 'whatsapp-link'
          const whatsappLink = document.getElementById("whatsapp-link");
          if (whatsappLink) {
            console.log('Elemento con ID "whatsapp-link" detectado en el DOM');
            // Agregar evento click para enviar eventos de tracking
            whatsappLink.addEventListener("click", () => {
              console.log("Clic en WhatsApp detectado");
              if (typeof gtag === "function") {
                gtag("event", "adw_whatsapp_chat");
              }
              if (typeof fbq === "function") {
                fbq("track", "Contact", { content_name: "whatsapp" });
              }
            });
            // Detener la observación una vez encontrado
            observer.disconnect();
            break;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    */

  /*
  * APP: https://apps.shopify.com/whatsapp-sharing
  */
  /*
    window.spWhatsAppTrack = function(buttonType){
       if(buttonType == 'widgetButton'){
            if (typeof gtag == 'function') {
                gtag('event', 'click', { 'event_category': 'telefono', 'event_label': 'whatsapp' });
            };
            if (typeof ga == 'function') {
                ga('send', 'event', 'telefono', 'click', 'whatsapp');
            };
            if (typeof fbq == 'function') {
                fbq('track', 'Contact', { content_name: 'whatsapp' });
            };
           console.log('click in whatsapp');
         
       }
    };
    */

  // jQuery is not loaded
  console.log("without jquery load");

  /**
   * Activacion e incrustación de clases para eventos
   */
  /*
  const btnCarrito = document.querySelector(".cart__checkout-button");

  if (btnCarrito) {
    btnCarrito.classList.add("btn-cart-checkout-adview");

    btnCarrito.addEventListener("click", function () {
      if (typeof gtag === "function") {
        gtag("event", "adw_click_cart_checkout");
      }
    });
  }
  */

  document.querySelectorAll('a[href^="tel"]').forEach((element) => {
    element.classList.add("link-phone");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_phone");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "telefono" });
      }
    });
  });
  document.querySelectorAll('a[href^="mailto"]').forEach((element) => {
    element.classList.add("link-email");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_click_email");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "email" });
      }
    });
  });
  document.querySelectorAll('a[href*="wa.me"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="api.whatsapp"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });
  document.querySelectorAll('a[href*="wa.link"]').forEach((element) => {
    element.classList.add("link-whatsapp");
    element.setAttribute("target", "_blank");
    element.addEventListener("click", function () {
      if (typeof gtag == "function") {
        gtag("event", "adw_whatsapp");
      }
      if (typeof fbq == "function") {
        fbq("track", "Contact", { content_name: "whatsapp" });
      }
    });
  });

})